module.exports = __webpack_public_path__ + "static/vast_oasis-c7332730d05d90d983c01c4eba65bad2.png";